export const CREATE_PRODUCT = `
mutation createProduct(
    $input: CreateProductInput!,
    $tenant_id: Int!,
  ){
  createProduct(
    input:$input,
    tenant_id:$tenant_id,
  ){
    __typename
    ...on Product{
    	  id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key      
    }
  }
}
`;

export const UPDATE_PRODUCT = `
mutation updateProduct(
    $input:  UpdateProductInput!,
    $tenant_id: Int!,
  ){
  updateProduct(
    input:$input,
    tenant_id:$tenant_id,
    
  ){
    __typename
    ...on Product{
    	  id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key      
    }
  }
}
`;

export const DELETE_PRODUCT = `
mutation deleteProduct(
    $id: Int!
$tenant_id: Int!,
){
deleteProduct(
id:$id
tenant_id:$tenant_id,
){
__typename
...on Product{
      id
}
...on ResultError{
  status_code
  message
  message_translation_key      
}
}
}
`;

export const SOLICIT_ADJUSTMENTS_OF_PRODUCT = `
mutation solicitAdjustmentsOfProduct(
  $tenant_id: Int!
  $input:MultipleActionOnProductsInputReasonRequired!
){
  solicitAdjustmentsOfProduct(
    tenant_id:$tenant_id
    input:$input
  ){
    __typename
    ...on Product{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
} 
`;

export const SOLICIT_REVISION_OF_PRODUCT = `
mutation solicitRevisionOfProduct(
  $tenant_id: Int!
  $input: MultipleActionOnProductsInput!
){
  solicitRevisionOfProduct(
    tenant_id: $tenant_id,
    input: $input
  ){
    __typename
    ...on Product{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const SOLICIT_APPROVAL_OF_PRODUCT = `
mutation solicitApprovalOfProduct(
  $tenant_id: Int!
  $input: MultipleActionOnProductsInput!
){
  solicitApprovalOfProduct(
    tenant_id: $tenant_id,
    input: $input
  ){
    __typename
    ...on Product{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const SOLICIT_REJECT_OF_PRODUCT = `
mutation solicitRejectOfProduct(
  $tenant_id: Int!
  $input: MultipleActionOnProductsInputReasonRequired!
){
  solicitRejectOfProduct(
    tenant_id: $tenant_id,
    input: $input
  ){
    __typename
    ...on Product{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TOGGLE_PRODUCT_STATUS = `
mutation toggleProductStatus(
  $tenant_id: Int!,
  $input: MultipleActionOnProductsInputActivationChange!
){
  toggleProductStatus(
    tenant_id:$tenant_id,
    input:$input
  ){
    __typename
  	...on Product{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const TOGGLE_PRODUCT_SPECIFICATION_STATUS = `
mutation toggleProductSpecificationStatus(
  $tenant_id: Int!,
  $input: MultipleActionOnProductSpecificationInputActivationChange!
){
  toggleProductSpecificationStatus(
    tenant_id:$tenant_id,
    input:$input
  ){
    __typename
    ...on ProductSpecification{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
